import React from 'react';
import { motion } from 'framer-motion';
import { BadgePlusIcon, CalculatorIcon, ClipboardCheckIcon, FileTextIcon, GiftIcon, HandshakeIcon, ShieldPlusIcon } from 'lucide-react';
import { BONUSES } from '../data/content';
const EXTRA_BONUSES = [{
  title: 'Guía de alta como autónomo/entrenador personal',
  label: 'Legal',
  icon: FileTextIcon
}, {
  title: 'Plantilla de acuerdo con fisioterapeutas/nutricionistas',
  label: 'Alianzas',
  icon: HandshakeIcon
}, {
  title: 'Kit de primera semana del alumno nuevo',
  label: 'Onboarding',
  icon: ClipboardCheckIcon
}, {
  title: 'Plantilla de informe de progreso para el alumno',
  label: 'Seguimiento',
  icon: BadgePlusIcon
}, {
  title: 'Rutinas de adaptación: hombro, cadera y rodilla',
  label: 'Adaptación',
  icon: ShieldPlusIcon
}, {
  title: 'Calculadora de proteínas, hidratación y horas de sueño para tus atletas',
  label: 'Bienestar',
  icon: CalculatorIcon
}];
export function Bonuses() {
  return <section className="px-5 py-10" data-id="element-28" data-mp="3iclojv2wsoze">
      <div className="mx-auto max-w-md" data-id="element-29" data-mp="3dfldt6v46y1y">
        <h2 className="text-center font-anton text-2xl leading-tight text-white sm:text-3xl" data-id="element-30" data-mp="3dek0swujg1hl">
          Espera, para ser un coach verdaderamente completo, aún falta esto:
        </h2>

        <div className="mx-auto mt-4 flex w-fit items-center gap-2 rounded-full border border-[#F5C518]/40 bg-[#F5C518]/10 px-4 py-1.5" data-id="element-31" data-mp="3n67qotbg5agy">
          <GiftIcon className="h-4 w-4 text-[#F5C518]" aria-hidden="true" data-id="element-32" data-mp="2zhoh8agnurna" />
          <span className="text-sm font-700 uppercase tracking-wide text-[#F5C518]" data-id="element-33" data-mp="2ui23lzwx79dy">
            11 bonos incluidos hoy
          </span>
        </div>

        <div className="mt-6 space-y-3" aria-label="Bonos incluidos" data-id="element-34" data-mp="33hfft0cfic2d">
          {BONUSES.map((bonus, index) => <motion.article key={bonus.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: Math.min(index * 0.04, 0.2)
        }} className="flex items-center gap-3 rounded-xl border border-[#F5C518]/30 bg-[#111]/95 p-3" data-id="element-35" data-mp="npi124mixioy" data-mpi={index}>
              <img src={bonus.image} alt="" className="h-16 w-16 shrink-0 rounded-lg border border-white/10 object-cover object-top" data-id="element-36" data-mp="3ljcp7jmznygm" />
              <div className="min-w-0 flex-1" data-id="element-37" data-mp="2tt81pc3xmvb6">
                <span className="font-oswald text-[10px] font-700 uppercase tracking-[0.14em] text-[#F5C518]" data-id="element-38" data-mp="2tqc3rns346mq">
                  Bono {index + 1}
                </span>
                <h3 className="mt-0.5 font-oswald text-[15px] font-700 leading-snug text-white" data-id="element-39" data-mp="32sblyjeu5gr9">
                  {bonus.title.replace(/^Bono \d+ — /, '')}
                </h3>
                <p className="mt-1 max-h-[34px] overflow-hidden text-[12px] leading-snug text-neutral-400" data-id="element-40" data-mp="2a57kgoeybkk8">
                  {bonus.description}
                </p>
              </div>
            </motion.article>)}

          <div className="flex items-center gap-3 pt-3" aria-label="Bonos extra incluidos" data-id="element-41" data-mp="27jhqhyevq4op">
            <span className="h-px flex-1 bg-[#F5C518]/25" data-id="element-42" data-mp="22m83epeyq541" />
            <p className="font-oswald text-xs font-700 uppercase tracking-[0.16em] text-[#F5C518]" data-id="element-43" data-mp="1xlk3tfco4fy7">
              Bonos extra
            </p>
            <span className="h-px flex-1 bg-[#F5C518]/25" data-id="element-44" data-mp="1tjp2wbyng4ky" />
          </div>

          {EXTRA_BONUSES.map(({
          title,
          label,
          icon: Icon
        }, index) => <motion.article key={title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: Math.min(index * 0.04, 0.2)
        }} className="flex items-center gap-3 rounded-xl border border-[#F5C518]/30 bg-[#111]/95 p-3" data-id="element-45" data-mp="1jup1yn0l6z44" data-mpi={index}>
              <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg bg-[#F5C518] text-black shadow-[0_4px_18px_rgba(245,197,24,0.18)]" data-id="element-46" data-mp="10vta3ic7awtg">
                <Icon className="h-7 w-7" aria-hidden="true" data-id="element-47" data-mp="30ylzaexej9mq" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-48" data-mp="34yw7zzckwe5a">
                <span className="font-oswald text-[10px] font-700 uppercase tracking-[0.14em] text-[#F5C518]" data-id="element-49" data-mp="2r897q2r66g73">
                  Extra · {label}
                </span>
                <h3 className="mt-0.5 font-oswald text-[15px] font-700 leading-snug text-white" data-id="element-50" data-mp="2w4zn0nv5h7rg">
                  {title}
                </h3>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}